import React from 'react';
import { motion } from 'framer-motion';
import { FiAward, FiUsers, FiTrendingUp } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  const stats = [
    { icon: FiAward, value: '$120M+', label: 'Sales Volume' },
    { icon: FiUsers, value: '250+', label: 'Happy Families' },
    { icon: FiTrendingUp, value: '12', label: 'Years Experience' },
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Image Side */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="absolute inset-0 bg-amber-600 rounded-lg transform translate-x-4 translate-y-4 -z-10"></div>
            <img 
              src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=800&auto=format&fit=crop" 
              alt="Eleanor Sterling - Real Estate Agent" 
              className="w-full h-[600px] object-cover rounded-lg shadow-xl"
            />
            <div className="absolute bottom-6 left-6 bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-bold text-slate-900">Eleanor Sterling</h3>
              <p className="text-amber-600 font-medium">Principal Broker</p>
            </div>
          </motion.div>

          {/* Content Side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-sm font-bold text-amber-600 uppercase tracking-widest mb-2">About Your Agent</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 font-serif">
              Dedicated to finding your perfect place in the world.
            </h3>
            <p className="text-slate-600 mb-6 leading-relaxed">
              With over a decade of experience in the luxury real estate market, I pride myself on delivering exceptional service, unmatched market knowledge, and a personalized approach to every client.
            </p>
            <p className="text-slate-600 mb-10 leading-relaxed">
              Whether you're looking to buy your first home, sell a cherished family estate, or build a profitable investment portfolio, my team and I are here to guide you through every step of the process with integrity and discretion.
            </p>

            <div className="grid grid-cols-3 gap-6 border-t border-slate-200 pt-10">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-slate-50 text-amber-600 mb-4">
                    <SafeIcon icon={stat.icon} className="text-xl" />
                  </div>
                  <div className="text-2xl font-bold text-slate-900 mb-1">{stat.value}</div>
                  <div className="text-xs text-slate-500 uppercase tracking-wide">{stat.label}</div>
                </div>
              ))}
            </div>
            
            <div className="mt-10">
              <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Signature_of_John_Hancock.svg" alt="Signature" className="h-12 opacity-40" />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;